











import { computed, defineComponent } from '@vue/composition-api'
import { useImagePlaceholder } from '@/composable/useImagePlaceholder'
import type { PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'ImagePreview',

  props: {
    value: {
      type: String,
      default: ''
    },
    size: {
      type: String as PropType<'x-small' | 'small' | 'medium' | 'large' | 'x-large'>,
      default: 'medium'
    },
    maxWidth: {
      type: [] as PropType<string | number | undefined>,
      default: undefined
    },
    placeholder: {
      type: String,
      default: ''
    }
  },

  setup(props) {
    const { currentPlaceholder, nextPlaceholder } = useImagePlaceholder([props.value, props.placeholder])

    const dimensions: Record<'x-small' | 'small' | 'medium' | 'large' | 'x-large', string> = {
      'x-small': '25',
      'small': '50',
      'medium': '75',
      'large': '100',
      'x-large': '200'
    }

    const dimension = computed((): string => (props.maxWidth ? String(props.maxWidth) : dimensions[props.size]))

    return {
      dimension,
      currentPlaceholder,
      nextPlaceholder
    }
  }
})
